/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { albumTracksModelSchema } from "../albumTracksModelSchema.ts";
import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { unitSchema } from "../unitSchema.ts";
import { z } from "zod";

export const postApiAlbumsIdTracksPathParamsSchema = z.object({
    "Id": z.string().uuid().describe("Идентификатор альбома")
    })

/**
 * @description Трек добавлен
 */
export const postApiAlbumsIdTracks200Schema = z.lazy(() => unitSchema)

/**
 * @description Ошибка валидации запроса | Неправильный запрос
 */
export const postApiAlbumsIdTracks400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const postApiAlbumsIdTracks401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const postApiAlbumsIdTracks403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Альбом не найден
 */
export const postApiAlbumsIdTracks404Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const postApiAlbumsIdTracks500Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Тело запроса
 */
export const postApiAlbumsIdTracksMutationRequestSchema = z.lazy(() => albumTracksModelSchema).describe("Тело запроса")

export const postApiAlbumsIdTracksMutationResponseSchema = z.lazy(() => postApiAlbumsIdTracks200Schema)